import React, { Component } from 'react';



export default class Invitation extends Component {
    static displayName = Invitation.name;

    constructor(props) {
        super(props);
        this.state = { invite: null,message:""};
        console.dir(props);
    }

    componentDidMount() {
        let { invite } = this.props.match.params;
        (async () => {
            this.getInvite(invite)
        })()
       
    }


    getInvite = async (inviteid) => {

        const resp = await fetch('api/team/getinvite?inviteid='+inviteid, {
            method: 'GET',
            credentials: 'same-origin'

        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();
                if (jdata.invite) {
                    this.setState({ invite: jdata.invite })

                }
                else {

                    this.setState({ message: jdata.statusText })
                }
            } catch (e) {
                const jdata = await resp.json();
                //console.log(jdata.statusText);
                this.setState({ message: jdata.statusText })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }       
        else {
            this.setState({ message: 'There was a problem, please try again later' });
            
        }
        
    }


    processInvite = async (accepted) => {
 
        var data = { accept: accepted, inviteid: this.state.invite.id }

        const resp = await fetch('api/team/processinvite', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }

        });
        
        if (resp.status === 200) {

            try {

                if (accepted) {
                    const teamid = this.state.invite.teamID;

                    await this.props.onTeamListChange(teamid);
                    this.props.history.push("/teams");
                }
                else {
                    this.props.history.push("/start");
                }


            } catch (e) {

                //console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
        }
    }
    render() {
        const inviteJSX = !!this.state.invite ? (
            <div>
                <div className="alert alert-info mb-3"> <h4>You have been invited to join {this.state.invite.teamName}</h4> </div>
                <button className ="btn btn-primary " onClick={()=>this.processInvite(true)}> Accept</button> &nbsp;
                <button className="btn btn-danger"   onClick={() => this.processInvite(false)}> Decline</button>
            </div>
        ):
            <div>{this.state.message } </div>

        return (
            <div>
                {inviteJSX}
            </div>
        );
    }
}
